import { Box, Grid2, Typography } from '@mui/material'
import React from 'react'
import { Constants, Page_Padding } from '../../shared/constants'
import { ImgText } from '../../shared/utils/Heading'
import { Link, useLocation } from 'react-router-dom';


export const LinearGradientText = ({ text }) => {
  return (
    <Typography
      variant="body2"
      sx={{
        background: "linear-gradient(90deg, #4169E1 0%, #DC143C 100%)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
      }}
    >
      {text}
    </Typography>
  );
};



const Layout = ({ children, firstSize, secondSize, title, text }) => {
  const location = useLocation();
  return (
    <Grid2 container className="body login" px={Page_Padding} sx={{ height: "100%" }} >
      <Grid2 children size={firstSize || 8} py={1}>
        <Link to={'/'}><img src={Constants.customImages.Logo} alt="logo" width={"200px"} height={"auto"} /></Link>
        <Typography variant='h1' fontWeight={500} mt={2}>
          Sign Up to  <br />
          My Application
        </Typography>
        {["/StudentLogin", "/ApartmentLogin", "/EmployeeLogin","/TrainerLogin"].includes(location.pathname) ? (
          <>
            <Typography variant="body2">
              If you don’t have an account you can
            </Typography>
            <Link to="/SelectSignupPath">
              <LinearGradientText text="Register here !!" />
            </Link>
          </>
        ) : (
          <>
            <Typography variant="body2">
              If you have an account you can
            </Typography>
            <Link to="/SelectLoginPath">
              <LinearGradientText text="Sign in here !!" />
            </Link>
          </>
        )}


      </Grid2>
      <Grid2
        container
        size={secondSize || 4}
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        textAlign={"center"}

      >   <Box>
          <Box mb={4} >
            <ImgText text={title ?? "Welcome!!"} sx={{ textAlign: "center" }} />
            <LinearGradientText text={text} />
          </Box>
          {children}
        </Box>
      </Grid2>
    </Grid2>
  )
}

export default Layout